import { useCallback } from 'react';
import { useRemoteConfig } from '@funtech-int/yango-shared';

import { useLocale } from '@/shared/hooks/useLocale';
import { clientConfig } from '@/config/client';

type LanguageToSupportLinkMap = Record<string, string>;

const { clientSupportLinks: defaultSupportLinks } = clientConfig;

export const useClientSupport = () => {
    const remoteConfig = useRemoteConfig();
    const supportLinks =
        (remoteConfig.flags.get('support_links') as LanguageToSupportLinkMap | undefined) ??
        defaultSupportLinks;

    const language = useLocale().lang;

    const clientSupportLink = supportLinks?.[language] ?? (defaultSupportLinks.en as string);

    const openClientSupport = useCallback(() => {
        window.open(clientSupportLink, '_blank');
    }, [clientSupportLink]);

    return { openClientSupport, clientSupportLink };
};
